import { bool, number, string, shape } from 'prop-types';
import React from 'react';
import AmpImg from 'components/AmpImg';
import AmpHtml from 'components/AmpHtml';
import styles from './styles';

export default function AmpListicle({
  image,
  html,
  title,
  isAffiliate,
  hasPrism
}) {
  return (
    <div className="AmpListicle">
      <AmpImg
        {...image}
        isAffiliate={isAffiliate}
        maxSize={{
          width: 534
        }}
        hasPrism={hasPrism}
      />
      <AmpHtml html={title} isAffiliate={isAffiliate} />
      <AmpHtml html={html} isAffiliate={isAffiliate} />
      <style jsx>{styles}</style>
    </div>
  );
}

AmpListicle.defaultProps = {
  html: '',
  title: '',
  image: {},
  isAffiliate: false,
  hasPrism: false
};

AmpListicle.propTypes = {
  html: string,
  title: string,
  image: shape({
    url: string,
    alt: string,
    caption: string,
    href: string,
    isPinnable: bool,
    originalWidth: number,
    originalHeight: number
  }),
  isAffiliate: bool,
  hasPrism: bool
};
